<template>
  <section class="modal">
    <svg class="modal__close" width="20" height="20" @click="close">
      <title>Закрыть</title>
      <use xlink:href="#plus" />
    </svg>
    <div v-if="modal.title" class="modal__title">{{ modal.title }}</div>
    <div v-if="modal.text" class="modal__text">{{ modal.text }}</div>
    <component :is="modal.component" v-if="modal.component" />
  </section>
</template>

<script>
export default {
  props: {
    modal: {
      type: Object,
      required: true
    }
  },

  mounted: function() {
    if (this.modal.background) {
      document.body.classList.toggle('-no-scroll');
    }
  },

  destroyed: function() {
    if (this.modal.background) {
      document.body.classList.toggle('-no-scroll');
    }
  },

  methods: {
    close: function() {
      this.$store.commit('NOTIFICATION_REMOVE_MODAL');
    }
  }
};
</script>

<style lang="scss" src="./modal.scss" />
